var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8333 21.2814C30.8333 28.2272 26.0573 31.7001 20.3806 33.7144C20.0834 33.8169 19.7605 33.812 19.4664 33.7005C13.776 31.7001 9 28.2272 9 21.2814V11.5573C9 11.1888 9.14377 10.8355 9.39968 10.575C9.65559 10.3145 10.0027 10.1681 10.3646 10.1681C13.0937 10.1681 16.5052 8.50111 18.8796 6.38959C19.1687 6.13815 19.5364 6 19.9167 6C20.2969 6 20.6647 6.13815 20.9537 6.38959C23.3418 8.51501 26.7396 10.1681 29.4687 10.1681C29.8307 10.1681 30.1777 10.3145 30.4336 10.575C30.6896 10.8355 30.8333 11.1888 30.8333 11.5573V21.2814Z",
    stroke: "#5B5B5B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 20C18.6192 20 17.4999 18.8807 17.4999 17.5C17.4999 16.1193 18.6192 15 19.9999 15C21.3806 15 22.4999 16.1193 22.4999 17.5C22.4999 18.8807 21.3806 20 19.9999 20ZM15.5273 25C15.7761 22.75 17.6836 21 19.9999 21C22.3162 21 24.2237 22.75 24.4724 25H15.5273Z",
    fill: "#EB5424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdp);
export default __webpack_public_path__ + "static/media/IDP.daecc978c6f1f4b0501659b65f5e4338.svg";
export { ForwardRef as ReactComponent };